import React, { useState } from "react";
import deleteIcon from "../../assets/svg/delete_white.svg";

const DeleteConfirmModal = ({ onConfirm, onCancel }) => {
  const [remarks, setRemarks] = useState("");

  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1050,
    },
    modal: {
      backgroundColor: "#ffffff",
      padding: "32px",
      borderRadius: "24px",
      width: "480px",
      textAlign: "center",
      boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
      fontFamily: "'Epilogue', sans-serif",
    },
    iconOuter: {
      width: "64px",
      height: "64px",
      borderRadius: "50%",
      backgroundColor: "#FFE2E3", // light red
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      margin: "0 auto 24px auto",
      boxShadow: "0 0 0 10px rgba(255, 226, 227, 0.4)", // extra outer ring
    },
    iconInner: {
      width: "48px",
      height: "48px",
      borderRadius: "50%",
      backgroundColor: "#FF4B4B", // bright red
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    title: {
      fontSize: "22px",
      fontWeight: "700",
      color: "#172b4d",
      marginBottom: "8px",
    },
    subtitle: {
      fontSize: "14px",
      color: "#8790A1",
      marginBottom: "24px",
      fontWeight: "400",
    },
    inputGroup: {
      textAlign: "left",
      marginBottom: "28px",
    },
    label: {
      display: "block",
      fontSize: "13px",
      fontWeight: "600",
      color: "#172B4D",
      marginBottom: "8px",
    },
    textarea: {
      width: "100%",
      height: "80px",
      padding: "12px",
      borderRadius: "12px",
      border: "1px solid #E5E5E5",
      fontSize: "14px",
      color: "#172b4d",
      outline: "none",
      resize: "none",
    },
    buttonsContainer: {
      display: "flex",
      justifyContent: "center",
      gap: "16px",
    },
    btnCancel: {
      padding: "12px 24px",
      borderRadius: "50px",
      border: "1px solid #E5E5E5",
      backgroundColor: "#FFFFFF",
      color: "#172b4d",
      fontSize: "15px",
      fontWeight: "600",
      cursor: "pointer",
      flex: 1,
      transition: "background-color 0.2s",
    },
    btnConfirm: {
      padding: "12px 24px",
      borderRadius: "50px",
      border: "none",
      backgroundColor: "#FF4B4B",
      color: "#FFFFFF",
      fontSize: "15px",
      fontWeight: "600",
      cursor: "pointer",
      flex: 1,
      transition: "background-color 0.2s",
    },
  };

  return (
    <div style={modalStyle.overlay}>
      <div style={modalStyle.modal}>
        {/* Icon */}
        <div style={modalStyle.iconOuter}>
          <div style={modalStyle.iconInner}>
            {/* Fallback svg if generic delete_white is missing/different */}
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="3 6 5 6 21 6"></polyline>
              <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
              <line x1="10" y1="11" x2="10" y2="17"></line>
              <line x1="14" y1="11" x2="14" y2="17"></line>
            </svg>
          </div>
        </div>

        {/* Text */}
        <div style={modalStyle.title}>Delete Reference?</div>
        <div style={modalStyle.subtitle}>Are you sure want to delete this record?</div>

        {/* Remarks Input */}
        <div style={modalStyle.inputGroup}>
          <label style={modalStyle.label}>Remarks</label>
          <textarea style={modalStyle.textarea} placeholder="Enter here..." value={remarks} onChange={(e) => setRemarks(e.target.value)} onFocus={(e) => (e.target.style.borderColor = "#FF4B4B")} onBlur={(e) => (e.target.style.borderColor = "#E5E5E5")} />
        </div>

        {/* Buttons */}
        <div style={modalStyle.buttonsContainer}>
          <button style={modalStyle.btnCancel} onClick={onCancel} onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#F9F9F9")} onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#FFFFFF")}>
            No, I don't
          </button>
          <button style={modalStyle.btnConfirm} onClick={() => onConfirm(remarks)} onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#E64343")} onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#FF4B4B")}>
            Yes, Proceed
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
